<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('baDatadictDetail:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="字典类型主表id">
                <a-input v-model="queryParam.dictId" allow-clear placeholder="请输入字典类型主表id"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="父级id">
                <a-input v-model="queryParam.parentId" allow-clear placeholder="请输入父级id"/>
              </a-form-item>
            </a-col> -->
            <!-- <template v-if="advanced"> -->
            <!-- <a-col :md="8" :sm="24">
                <a-form-item label="字典明细值">
                  <a-input v-model="queryParam.detailValue" allow-clear placeholder="请输入字典明细值"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="字典明细名称">
                  <a-input v-model="queryParam.detailName" allow-clear placeholder="请输入字典明细名称"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="字典明细介绍">
                  <a-input v-model="queryParam.detailDesc" allow-clear placeholder="请输入字典明细介绍"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="拼音">
                  <a-input v-model="queryParam.pinyin" allow-clear placeholder="请输入拼音"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="排序值">
                  <a-input v-model="queryParam.seqno" allow-clear placeholder="请输入排序值"/>
                </a-form-item>
              </a-col> -->
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-date-picker style="width: 100%" placeholder="请选择创建时间"  :allow-clear="false" v-model="queryParam.ctstampDate"
                  @change="onChangectstamp" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="修改时间">
                <a-date-picker style="width: 100%" placeholder="请选择修改时间" :allow-clear="false" v-model="queryParam.utstampDate"
                  @change="onChangeutstamp" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否启用">
                <a-select v-model="queryParam.useflag" placeholder="请选择">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value="0">禁用</a-select-option>
                  <a-select-option value="1">启用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- </template> -->
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert"
        :rowKey="(record) => record.valueId" :rowSelection="options.rowSelection">
        <template class="table-operator" slot="operator" v-if="hasPerm('baDatadictDetail:add')">
          <!-- <a-button type="primary" v-if="hasPerm('baDatadictDetail:add')" icon="plus" @click="$refs.addForm.add()">
            新增科目管理</a-button> -->
          <!-- <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('baDatadictDetail:delete')"
            @click="batchDelete">
            <a-icon type="delete" />批量删除
          </a-button> -->
          <!-- <x-down v-if="hasPerm('baDatadictDetail:export')" ref="batchExport" @batchExport="batchExport" /> -->
        </template>
>
        <span slot="ifAccepted" slot-scope="text, record">
          {{record.ifAccepted == '1'? '已备案' : '未备案' }}
        </span>

        <span slot="action" slot-scope="text, record">
          <a style="margin-right: 10px;" @click="upData(record)">{{ record.ifAccepted == 0 ? '备案' : record.ifAccepted == 1 ?
          '重新备案' : '备案' }}</a>
            <a style="margin-right: 10px;" @click="cancelData(record)" v-if="record.ifAccepted == 1">取消备案</a>
        </span>

      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { baDatadictDetailPage, baDatadictDetailDelete, upDataList } from '@/api/modular/interhospital/deptClass/deptClassManage'
  import addForm from './addForm.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '科目名称',
            align: 'center',
            dataIndex: 'deptClassName'
          },
          {
            title: '诊疗科目编码',
            align: 'center',
            dataIndex: 'deptClassCode'
          },
          {
            title: '医疗机构编码',
            align: 'center',
            dataIndex: 'unifiedOrgCode'
          },
          {
            title: '互联网执业许可发证日期',
            align: 'center',
            dataIndex: 'authorizeDate'
          },
          {
            title: '互联网执业许可到期日期',
            align: 'center',
            dataIndex: 'expireDate'
          },
          // {
          //   title: '是否准予开设',
          //   align: 'center',
          //   dataIndex: 'ifAccepted',
          //   scopedSlots: { customRender: 'ifAccepted' },
          // },
          {
            title: '是否备案',
            align: 'center',
            dataIndex: 'ifAccepted',
            scopedSlots: { customRender: 'ifAccepted' },
          },
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return baDatadictDetailPage(Object.assign(parameter, this.switchingDate())).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      // if (this.hasPerm('baDatadictDetail:edit') || this.hasPerm('baDatadictDetail:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      // }
    },
    methods: {
      moment,
      // 备案功能
      upData(record){
        let params = {
          valueId : record.valueId,
          uploadFlag: '1'
        }
        upDataList(params).then(res=>{
            console.log(res)
            if(res.code == 200){
              this.$message.success('备案成功');
              this.handleOk();
            }else{
              this.$message.error('请稍后重试');
            }
        })
      },
      /* *
      取消备案
      *
      */
      cancelData(record){
        let params = {
          valueId : record.valueId,
          uploadFlag: '0'
        }
        upDataList(params).then(res=>{
            console.log(res)
            if(res.code == 200){
              this.$message.success('取消备案成功');
              this.handleOk();
            }else{
              this.$message.error('请稍后重试');
            }
        })
      },
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamctstamp = this.queryParam.ctstampDate
        if (queryParamctstamp != null) {
            this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
            if (queryParamctstamp.length < 1) {
                delete this.queryParam.ctstamp
            }
        }
        const queryParamutstamp = this.queryParam.utstampDate
        if (queryParamutstamp != null) {
            this.queryParam.utstamp = moment(queryParamutstamp).format('YYYY-MM-DD')
            if (queryParamutstamp.length < 1) {
                delete this.queryParam.utstamp
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'valueId': record.valueId }]
        this.baDatadictDetailDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'valueId': d }
        })
        this.baDatadictDetailDelete(paramIds)
      },
      baDatadictDetailDelete (record) {
        baDatadictDetailDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      onChangeutstamp(date, dateString) {
        this.utstampDateString = dateString
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'valueId': d }
        })
        baDatadictDetailExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
